import { useQuery } from '@apollo/client/react';
import { useACLCan } from 'app/domains/filesystem';
import { useAccount } from 'shared/domains/users';
import { GetDocumentMetadataDocument } from './GetDocumentMetadata.gql';
import { getSystemData } from './getSystemData';
import { getPropertyPairs, checkFeatureAvailability } from './utils';
export function useGetDocumentMetadata(documentId) {
    var _a, _b;
    const { data, error, loading, refetch } = useQuery(GetDocumentMetadataDocument, {
        skip: !documentId,
        variables: { documentId },
        fetchPolicy: 'cache-and-network',
    });
    const account = useAccount();
    const { companyId } = account.data || {};
    const { accessLevel } = useACLCan({ userAcls: (_a = data === null || data === void 0 ? void 0 : data.systemData) === null || _a === void 0 ? void 0 : _a.acls, teamAcls: (_b = data === null || data === void 0 ? void 0 : data.systemData) === null || _b === void 0 ? void 0 : _b.teamAcls });
    const properties = data ? getPropertyPairs(data, companyId) : [];
    const systemData = getSystemData(data === null || data === void 0 ? void 0 : data.systemData);
    const autoTaggingFeatureAvailable = checkFeatureAvailability(data);
    const handleRefetch = () => refetch({ documentId });
    return {
        error,
        loading,
        accessLevel,
        properties,
        systemData,
        autoTaggingFeatureAvailable,
        refetch: handleRefetch,
    };
}
